/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export enum ProgramScreenConstants {
    TEXT = 'text',
    SEASONS = 'seasons',
    UPCOMING_AIRING = 'upcoming-airing',
    ALL_UPCOMING_EPISODES = 'all-upcoming-episodes',
    ALL_EPISODES = 'all-episodes',
    ON_DEMAND_EPISODES = 'on-demand-episodes',
    CAST = 'cast',
    VIEW_ALL = 'view-all',
    EMPTY_STRIP = 'empty-strip',
    LOADING_STRIP = 'loading-strip',
}
